<h3>Historique</h3>

<ng-container>

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z2 w-full">

        <!-- Date -->
        <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef>Date</th>
            <td mat-cell *matCellDef="let h">
                {{ h.dateHistorique | date: 'short' }}
            </td>
        </ng-container>

        <!-- Acteur -->
        <ng-container matColumnDef="auteurNom">
            <th mat-header-cell *matHeaderCellDef>Acteur</th>
            <td mat-cell *matCellDef="let h">{{ h.auteurNom }}</td>
        </ng-container>

        <!-- Nature -->
        <ng-container matColumnDef="nature">
            <th mat-header-cell *matHeaderCellDef>Nature</th>
            <td mat-cell *matCellDef="let h">
                <mat-icon [ngClass]="{
              'icon-create': h.nature === 'create',
              'icon-update': h.nature === 'update',
              'icon-delete': h.nature === 'delete',
              'icon-notice': h.nature === 'notice',
              'icon-default': !['create', 'update', 'delete', 'notice'].includes(h.nature)
            }" matTooltip="{{ h.nature }}">
                    {{ getNatureIcon(h.nature) }}
                </mat-icon>
            </td>
        </ng-container>

        <!-- Description -->
        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef>Description</th>
            <td mat-cell *matCellDef="let h">{{ h.description }}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <!-- MESSAGE SI AUCUN HISTORIQUE -->
    @if (dataSource.data.length === 0) {
    <div class="empty-state">
        Aucun historique à afficher.
    </div>
    }

    <!-- PAGINATOR UNIQUEMENT S'IL Y A DES DONNÉES -->
    <mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 15]" showFirstLastButtons>
    </mat-paginator>

</ng-container>